<template>
  <div class="modal">
    <div class="modal-container" v-if="repeated_invites && !invite_send">
      <div>
        <h3 class="modal-title">{{ $tr('invite.express.quest') }}</h3>
        <div class="modal-text">
          {{ $tr('searchResults.results.candidates.header.candidate') }}
          <span>{{ email }}</span>
          {{ $tr('invite.express.textModal') }}
        </div>
      </div>

      <div>
        <vbutton
          class="express-btn"
          label="actions.invite"
          :loading="loading"
          @click="send"
        />
        <vbutton
          class="grey express-btn"
          text_color="red"
          label="common.cancel"
          @click="cancel"
        />
      </div>
    </div>

    <div class="modal-container modal-container_send" v-if="invite_send">
      <div class="modal-icon">
        <img src="/static/images/elements/icon_ok.png" />
      </div>

      <div>
        <h3 class="modal-title">{{ $tr('invites.success') }}</h3>
      </div>

      <div class="modal-footer">
        <vbutton class="button-ok" label="common.ok" @click="cancel" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal-remove-vacancy',

    props: {
      email: {
        type: String,
        default: null
      },
      invite_send: {
        type: Boolean,
        default: false
      },
      repeated_invites: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      send() {
        this.$emit('send');
      },
      cancel() {
        this.$emit('cancel');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .modal {
    position: absolute;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: flex-end;
    transition: opacity 0.3s ease;

    &-container {
      width: 600px;
      height: 300px;
      margin: 0 auto 45px;
      padding: 81px 10px 85px;
      background-color: #fff;
      border-radius: 2px;
      transition: all 0.3s ease;
      text-align: center;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;

      &_send {
        padding: 63px 10px 0;
      }
    }

    &-title {
      // font-family: 'Roboto', sans-serif;
      font-weight: 500;
      line-height: 41px;
      font-size: 28px;
      color: #233346;
      margin: 0;
    }

    &-text {
      font-size: 15px;
      line-height: 22px;
      margin: 12px 0 22px;

      span {
        font-weight: 700;
      }
    }

    &-icon {
      display: block;
      margin-bottom: 18px;
    }

    &-footer {
      margin-top: 14px;
    }

    .express-btn {
      width: 120px;
      margin: 0 10px;
    }

    .button-ok {
      min-width: 80px;
      max-width: 80px;
    }
  }
</style>
